import React, { useEffect } from 'react'
import { useSelector } from 'hooks/use-redux'
import BillingProviderLoadError from 'components/common/billing-provider-load-error'
import Alert from 'components/ui/alert'
import Spinner from 'components/ui/spinner'
import useScript from '@disco/utils/use-script'
import { getChargebeeConfig } from '@disco/utils/chargebee'

type Props = {
  onLoad: (...args: Array<any>) => any
  onError?: (...args: Array<any>) => any
}

const ChargebeeLoader = () => {
  const app = useSelector(state => state.app)

  return !app.online ? (
    <Alert icon="warning" status="warning">
      There are issues with your connection preventing payment from completing.
      Please check your connection and try again.
    </Alert>
  ) : null
}

const ChargebeeScriptLoader = ({ onLoad, onError }: Props): React.ReactNode => {
  const [loaded, error, retryLoadChargebeeScript] = useScript(
    'https://js.chargebee.com/v2/chargebee.js',
  )

  useEffect(() => {
    if (error) {
      onError(error)
    } else if (loaded) {
      const config = getChargebeeConfig()
      window.Chargebee.init(config)
      onLoad()
    }
  }, [loaded, error])

  if (!loaded) {
    return <Spinner />
  }

  if (loaded && error && !window.Chargebee) {
    return (
      <BillingProviderLoadError retryLoadScript={retryLoadChargebeeScript} />
    )
  }

  return <ChargebeeLoader />
}

export default ChargebeeScriptLoader
